import { AutogenModelEdiMovementOrder, AutogenRowEdiMovementOrder } from "./autogen/AutogenModelEdiMovementOrder";

export class ModelEdiMovementOrder extends AutogenModelEdiMovementOrder<RowEdiMovementOrder> {
	constructor() {
		super(RowEdiMovementOrder);
	}
}

export class RowEdiMovementOrder extends AutogenRowEdiMovementOrder {
}